import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../components/common';
import { Truncated } from './components';
import styles from './components/Truncated/Truncated.scss';
import { GenericNotification } from './GenericNotification';

export const moveToNotification =
  ({ items, targetName, onTargetClick }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id="files-manager.move-to-notification"
            values={{
              itemName: <Truncated>{items[0].name}</Truncated>,
              itemsCount: items.length,
              targetName: (
                <TextButton
                  className={styles.truncated}
                  as="a"
                  size="small"
                  underline="always"
                  onClick={onTargetClick}
                  skin="dark"
                  dataHook="notification-link"
                >
                  {targetName}
                </TextButton>
              ),
            }}
          />
        }
      />
    );
